<tt-page *ngIf="!!year && !!countryId">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selections"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <ng-container *ngTemplateOutlet="list"></ng-container>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="selections"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-6 p-5">
            <ng-container *ngTemplateOutlet="list"></ng-container>
        </div>
    </div>
</tt-page>

<ng-template #selections>
    <ng-container *ngIf="!!year && !!countryId">
        <tt-select ttLabel="country" [(ttModel)]="countryId" [ttData]="selectListCountries" (ttModelChange)="onChanged($event, 'countryId')" ttDataId="country_id" ttDataName="country_name"></tt-select>
        <tt-select ttLabel="year" [(ttModel)]="year" [ttData]="selectListYears" (ttModelChange)="onChanged($event, 'year')" ttDataId="item_id" ttDataName="item_name"></tt-select>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!year && !!countryId">
        <tt-button-goto [ttText]="'new_holiday'" (ttClick)="goToFunc('holiday')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </ng-container>
</ng-template>

<ng-template #list>
    <ng-container *ngIf="!!year && !!countryId">
        <tt-list [ttData]="itemsListHolidays"></tt-list>
    </ng-container>
</ng-template>
